var img = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M0 12C0 5.37258 5.37258 0 12 0H24V24H12C5.37258 24 0 18.6274 0 12Z' fill='%234B4B4B' /%3e %3cpath d='M14.3335 7.3335L9.66683 12.0002L14.3335 16.6668' stroke='%238E8E8E' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' /%3e%3c/svg%3e";
  var PbNavigationCurvedFilled = img;

export { PbNavigationCurvedFilled as default };
